import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import{DriverVehicleLinkContainerModel} from '../../../../../../../models/aggregates/erp/delivery/driver-vehicle-link/driver-vehicle-link-container.model';
import { BaseApiTemplateService, Core2Config, ApiVisa } from '../../../shared';
import { DriverVehicleLinkCriteriaModelQuery, DriverVehicleLinkQueryCriteriaClass } from '../../../../criteria/driver-vehicle-link-criteria.model';
import { Observable } from 'rxjs';
import { ApiResponseModel } from '../../../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})
export class DriverVehicleLinkService extends BaseApiTemplateService<DriverVehicleLinkContainerModel> {
  // https://api-test.akaun.com/core2/tnt/dm/del/drivers
  readonly url = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/driver-vehicle-links';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/driver-vehicle-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'del/driver-vehicle-links';
    this.httpClient = http;
  }

  getObjByCriteria(visa: ApiVisa, criteria?: DriverVehicleLinkQueryCriteriaClass):
    Observable<ApiResponseModel<DriverVehicleLinkContainerModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const buildEntityCriteriaCriteria = new DriverVehicleLinkCriteriaModelQuery(criteria);
    return this.httpClient.get<ApiResponseModel<DriverVehicleLinkContainerModel>>(this.apiUrl + '/query?' +
      buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }
}